module.exports = __webpack_public_path__ + "assets/img/custom-paperwallet/icon-light.566621685c5ea922de5a6dba59826d06.svg";